import styled from "styled-components";

export const SearchBarContainer = styled.div`
    padding: 4px 10px;
`;

export const BulkActionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: -7px;
    padding: 5px 14px;
`;
